type Value = string | number;

type Unit = (n: Value) => string;

type ToREM = (n: Value) => string;

type TRBL = (t: Value, r: Value, b: Value, l: Value) => string;
type TXB = (t: Value, x: Value, b: Value) => string;
type YX = (y: Value, x: Value) => string;

type BorderStyle =
  | 'dotted'
  | 'dashed'
  | 'solid'
  | 'double'
  | 'groove'
  | 'ridge'
  | 'inset'
  | 'outset'
  | 'none'
  | 'hidden';
type Border = (width: number, style: BorderStyle, color: string) => string;

export const rem: Unit = n => `${n}rem`;
export const vh: Unit = n => `${n}vh`;
export const vw: Unit = n => `${n}vw`;

export const toREM: ToREM = v =>
  typeof v === 'string' || v === 0 ? `${v}` : rem(v);

// trbl = top, right, bottom, left
export const trbl: TRBL = (t, r, b, l) =>
  `${toREM(t)} ${toREM(r)} ${toREM(b)} ${toREM(l)}`;

// txb = top, x, bottom
export const txb: TXB = (t, x, b) => `${toREM(t)} ${toREM(x)} ${toREM(b)}`;

export const yx: YX = (y, x) => `${toREM(y)} ${toREM(x)}`;

export const border: Border = (w, s, c) => `${w}px ${s} ${c}`;

export interface Units {
  rem: Unit;
  vh: Unit;
  vw: Unit;
  trbl: TRBL;
  txb: TXB;
  yx: YX;
  border: Border;
}

const units: Units = { rem, vh, vw, trbl, txb, yx, border };

export default units;
